import { Badge } from "../../../Component/RetailerMainComponents/Badge";
import { SectionCard } from "../../../Component/RetailerMainComponents/SectionCard";
import {
  FileText,
  FileDown,
} from "lucide-react";

export default function DocumentsView() {
  const authUser = JSON.parse(localStorage.getItem("authUserData")) || {};

  const userRole = authUser?.role;
  const sessionId = authUser?.id;

  const isRetailerMobile =
  window.innerWidth < 640 && userRole === 5;


  // 🔥 Mock data directly inside component (NO props)
  const documents = {
  // ---------------- LEGAL AGREEMENTS ----------------
  privacyPolicyAccepted: Boolean(authUser.is_verified >= 6),
  termsAccepted: Boolean(authUser.is_verified >= 6),
  agreementSigned: Boolean(authUser.esign_verified === 1),

  // ---------------- PAYMENT TERMS ----------------
  paymentTermDays: authUser.is_payment_success === 1 ? 30 : 0,

  // ---------------- KYC DOCUMENTS ----------------
  fetchedDocs: [
    {
      id: 1,
      label: "PAN Card",
      source: authUser.pan ? "Upload" : "Not Submitted",
      maskedId: authUser.pan
        ? `XXXXX${authUser.pan.slice(-4)}`
        : "-",
      status: authUser.pan_verified === 1
        ? "Verified"
        : authUser.pan
        ? "Pending"
        : "Pending",
    },
    {
      id: 2,
      label: "GST Certificate",
      source: authUser.gst ? "Upload" : "Not Submitted",
      maskedId: authUser.gst
        ? `GST-${authUser.gst.slice(-4)}`
        : "-",
      status: authUser.gst_verified == 1
        ? "Verified"
        : "Pending",
    },
    {
      id: 3,
      label: "Address Proof",
      source: authUser.address_line1 ? "System" : "Not Submitted",
      maskedId: authUser.pincode || "-",
      status: authUser.address_line1
        ? "Verified"
        : "Pending",
    },
  ],
};


  const allAccepted =
    documents.privacyPolicyAccepted &&
    documents.termsAccepted &&
    documents.agreementSigned;

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">

        {/* ---------------- LEGAL AGREEMENTS ---------------- */}
        <SectionCard title="Legal Agreements" isRetailerMobile={isRetailerMobile} >
          <div className="space-y-2 text-xs">
            <div className="flex items-center justify-between">
              <span>Privacy Policy</span>
              <Badge color={documents.privacyPolicyAccepted ? "green" : "gray"}>
                {documents.privacyPolicyAccepted ? "Accepted" : "Pending"}
              </Badge>
            </div>

            <div className="flex items-center justify-between">
              <span>Terms & Conditions</span>
              <Badge color={documents.termsAccepted ? "green" : "gray"}>
                {documents.termsAccepted ? "Accepted" : "Pending"}
              </Badge>
            </div>

            <div className="flex items-center justify-between">
              <span>Sign Agreement</span>
              <Badge color={documents.agreementSigned ? "green" : "gray"}>
                {documents.agreementSigned ? "Signed" : "Pending"}
              </Badge>
            </div>

            <div className="pt-2 text-[11px] text-slate-500">
              {allAccepted ? (
                <span>
                  All legal documents are completed. You can download the signed
                  agreement for your records.
                </span>
              ) : (
                <span>
                  Some documents are still pending. Please complete them to avoid
                  payment delays.
                </span>
              )}
            </div>

            {/* <div className="flex flex-wrap gap-2 pt-2">
              <button className="text-[11px] px-2.5 py-1.5 rounded-lg border border-blue-200 text-blue-700 bg-blue-50 hover:bg-blue-100 inline-flex items-center gap-1">
                <FileText className="w-3 h-3" />
                <span>View Agreement</span>
              </button>

              <button className="text-[11px] px-2.5 py-1.5 rounded-lg border border-slate-200 text-slate-700 bg-slate-50 hover:bg-slate-100 inline-flex items-center gap-1">
                <FileDown className="w-3 h-3" />
                <span>Download Agreement</span>
              </button>
            </div> */}
          </div>
        </SectionCard>

        {/* ---------------- KYC DOCUMENTS ---------------- */}
        <SectionCard title="KYC Documents (DigiLocker / Upload)" isRetailerMobile={isRetailerMobile}>
          <div className="space-y-2 text-xs max-h-48 overflow-y-auto pr-1">

            {documents.fetchedDocs.map((doc) => {
              const color =
                doc.status === "Verified"
                  ? "green"
                  : doc.status === "Rejected"
                  ? "red"
                  : "yellow";

              return (
                <div
                  key={doc.id}
                  className={`
                    flex justify-between items-center p-3 rounded-2xl transition-all duration-300
                    ${
                      isRetailerMobile
                        ? "bg-white/10 backdrop-blur-xl border border-white/30 "
                        : "border border-slate-100 bg-slate-50"
                    }
                  `}
                >
                  <div>
                   <div
                      className={`font-semibold ${
                        isRetailerMobile ? "text-slate-900" : "text-slate-800"
                      }`}
                    >
                      {doc.label}
                    </div>
                    <div className="text-[11px] text-slate-500">
                      Source: {doc.source} · {doc.maskedId}
                    </div>
                  </div>
                  <Badge color={color}>{doc.status}</Badge>
                </div>
              );
            })}

            {documents.fetchedDocs.length === 0 && (
              <div className="text-xs text-slate-500">
                No documents fetched yet. Connect DigiLocker or upload KYC.
              </div>
            )}
          </div>
        </SectionCard>

        {/* ---------------- PAYMENT TERMS ---------------- */}
        <SectionCard title="Payment Terms" isRetailerMobile={isRetailerMobile}>
          <div className="space-y-2 text-xs">
            <div className="flex items-center justify-between">
              <span>Standard credit period</span>
              <span className="font-semibold text-slate-800">
                {documents.paymentTermDays} days
              </span>
            </div>

            <div className="text-[11px] text-slate-500">
              Payments are expected within the defined credit period from invoice
              date. Delays may attract interest or service restrictions as per
              agreement.
            </div>

            <div className="pt-2">
              <button
                className={`
                  text-[11px] px-3 py-1.5 rounded-xl inline-flex items-center gap-1.5
                  transition-all duration-300 active:scale-[0.97]
                  ${
                    isRetailerMobile
                      ? "bg-blue-400/20 text-blue-900 border border-blue-400/30 backdrop-blur-md shadow-sm"
                      : "border border-blue-200 text-blue-700 bg-blue-50 hover:bg-blue-100"
                  }
                `}
              >
                <FileText className="w-3 h-3" />
                <span>View Payment Terms</span>
              </button>
            </div>
          </div>
        </SectionCard>

      </div>
    </div>
  );
}


// import { Badge } from "../../../Component/RetailerMainComponents/Badge";
// import { SectionCard } from "../../../Component/RetailerMainComponents/SectionCard";
// import {
//   LayoutDashboard,
//   ShieldCheck,
//   FileText,
//   FileSpreadsheet,
//   Scale,
//   Wallet,
//   ReceiptIndianRupee,
//   FileBarChart2,
//   FileDown,
//   ArrowRight,
//   Users as UsersIcon,
//   UserPlus,
// } from "lucide-react";

// export default function DocumentsView({ documents }) {
//   const allAccepted =
//     documents.privacyPolicyAccepted &&
//     documents.termsAccepted &&
//     documents.agreementSigned;

//   return (
//     <div className="space-y-4">
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
//         <SectionCard title="Legal Agreements">
//           <div className="space-y-2 text-xs">
//             <div className="flex items-center justify-between">
//               <span>Privacy Policy</span>
//               <Badge color={documents.privacyPolicyAccepted ? "green" : "gray"}>
//                 {documents.privacyPolicyAccepted ? "Accepted" : "Pending"}
//               </Badge>
//             </div>
//             <div className="flex items-center justify-between">
//               <span>Terms & Conditions</span>
//               <Badge color={documents.termsAccepted ? "green" : "gray"}>
//                 {documents.termsAccepted ? "Accepted" : "Pending"}
//               </Badge>
//             </div>
//             <div className="flex items-center justify-between">
//               <span>Sign Agreement</span>
//               <Badge color={documents.agreementSigned ? "green" : "gray"}>
//                 {documents.agreementSigned ? "Signed" : "Pending"}
//               </Badge>
//             </div>
//             <div className="pt-2 text-[11px] text-slate-500">
//               {allAccepted ? (
//                 <span>
//                   All legal documents are completed. You can download the signed
//                   agreement for your records.
//                 </span>
//               ) : (
//                 <span>
//                   Some documents are still pending. Please complete them to
//                   avoid payment delays.
//                 </span>
//               )}
//             </div>
//             <div className="flex flex-wrap gap-2 pt-2">
//               <button className="text-[11px] px-2.5 py-1.5 rounded-lg border border-blue-200 text-blue-700 bg-blue-50 hover:bg-blue-100 inline-flex items-center gap-1">
//                 <FileText className="w-3 h-3" />
//                 <span>View Agreement</span>
//               </button>
//               <button className="text-[11px] px-2.5 py-1.5 rounded-lg border border-slate-200 text-slate-700 bg-slate-50 hover:bg-slate-100 inline-flex items-center gap-1">
//                 <FileDown className="w-3 h-3" />
//                 <span>Download Agreement</span>
//               </button>
//             </div>
//           </div>
//         </SectionCard>

//         <SectionCard title="KYC Documents (DigiLocker / Upload)">
//           <div className="space-y-2 text-xs max-h-48 overflow-y-auto pr-1">
//             {documents.fetchedDocs.map((doc) => {
//               const docBadgeColor =
//                 doc.status === "Verified"
//                   ? "green"
//                   : doc.status === "Rejected"
//                   ? "red"
//                   : "yellow";
//               return (
//                 <div
//                   key={doc.id}
//                   className="border border-slate-100 rounded-xl p-2 bg-slate-50 flex justify-between items-center"
//                 >
//                   <div>
//                     <div className="font-semibold text-slate-800">{doc.label}</div>
//                     <div className="text-[11px] text-slate-500">
//                       Source: {doc.source} · {doc.maskedId}
//                     </div>
//                   </div>
//                   <Badge color={docBadgeColor}>{doc.status}</Badge>
//                 </div>
//               );
//             })}
//             {documents.fetchedDocs.length === 0 && (
//               <div className="text-xs text-slate-500">
//                 No documents fetched yet. Connect DigiLocker or upload KYC.
//               </div>
//             )}
//           </div>
//         </SectionCard>

//         <SectionCard title="Payment Terms">
//           <div className="space-y-2 text-xs">
//             <div className="flex items-center justify-between">
//               <span>Standard credit period</span>
//               <span className="font-semibold text-slate-800">
//                 {documents.paymentTermDays} days
//               </span>
//             </div>
//             <div className="text-[11px] text-slate-500">
//               Payments are expected within the defined credit period from invoice
//               date. Delays may attract interest or service restrictions as per
//               agreement.
//             </div>
//             <div className="pt-2">
//               <button className="text-[11px] px-2.5 py-1.5 rounded-lg border border-blue-200 text-blue-700 bg-blue-50 hover:bg-blue-100 inline-flex items-center gap-1">
//                 <FileText className="w-3 h-3" />
//                 <span>View Payment Terms</span>
//               </button>
//             </div>
//           </div>
//         </SectionCard>
//       </div>
//     </div>
//   );
// }